import { NewsLetterRequest, postContactNewsLetter } from "api"
import { getUtmParamsAsKeyValueList } from "common/bit/utils/utmParams"
import { getFormName } from "common/getFormName"

export type NewsletterPlatform = NewsLetterRequest["platform"]

export const NEWSLETTER_FORM_NAME = getFormName("newsletter")

export const submitNewsletter = async (
  emailAddress: string,
  platform: NewsletterPlatform
): Promise<boolean> => {
  const payload: NewsLetterRequest = {
    emailAddress: emailAddress.trim(),
    platform,
    isMailing: true,
    utmValues: getUtmParamsAsKeyValueList(),
    sid: window?.__ctm?.config?.sid || "",
    formName: NEWSLETTER_FORM_NAME,
  }

  const response = await postContactNewsLetter(payload)
  return response?.data?.body === true
}
